export const cilTriangle = ["24 24","<path d='M12.813 3.096c-0.165-0.283-0.467-0.471-0.813-0.471s-0.648 0.187-0.811 0.466l-0.002 0.004-9.801 17.061c-0.078 0.134-0.125 0.295-0.125 0.467 0 0.518 0.42 0.938 0.937 0.938 0 0 0 0 0 0h19.602c0.518 0 0.938-0.42 0.938-0.938 0-0.172-0.046-0.333-0.127-0.471l0.002 0.004zM3.171 20.061l8.829-15.369 8.829 15.369z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-triangle.js
// module id = null
// module chunks = 